module.exports = __webpack_public_path__ + "img/marker.5998204b.png";